import React, { useState, useEffect } from "react";
import "./ScrollToFooter.scss";

const ScrollToFooter = () => {
  const [isBottomHalf, setIsBottomHalf] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const halfwayPoint = (documentHeight - windowHeight) / 2;

      setIsBottomHalf(scrollPosition > halfwayPoint);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    if (isBottomHalf) {
      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Scroll to footer
      const footer = document.querySelector('.footer');
      if (footer) {
        footer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <button
      className={`scroll-to-footer ${isBottomHalf ? 'scroll-to-footer--up' : ''}`}
      onClick={handleClick}
      aria-label={isBottomHalf ? "Scroll to top" : "Scroll to footer"}
    >
      {isBottomHalf ? (
        // Arrow UP
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 19V5M5 12l7-7 7 7" />
        </svg>
      ) : (
        // Arrow DOWN
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 5v14M19 12l-7 7-7-7" />
        </svg>
      )}
    </button>
  );
};

export default ScrollToFooter;

